/** @param {string} surveyUrl */
export function setupNpsSurvey(surveyUrl) {
  ;(function (t, e, s, o) {
    var n, a, c
    ;(t.SMCX = t.SMCX || []),
      e.getElementById(o) ||
        ((n = e.getElementsByTagName(s)),
        (a = n[n.length - 1]),
        (c = e.createElement(s)),
        (c.type = 'text/javascript'),
        (c.async = !0),
        (c.id = o),
        (c.src = surveyUrl),
        a.parentNode.insertBefore(c, a))
  })(window, document, 'script', 'smcx-sdk')
}
